import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./health.css"
import { Link } from 'react-router-dom';

import Healthimg from "../../../assets/images/Industry Page/healthcare.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-healthcare";
import Swiper from "../Bfsi Solution/swiper";
import SEO from "../../seo";

export default function HealthCare() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="Healthcare"
                description="Industries Take Advantage of The Best Healthcare Software Development Welcome to Horizon WebInfo Pvt Ltd, where innovation meets healthcare excellence. We&#8217;re dedicated to revolutionizing the healthcare landscape through cutting-edge software solutions designed to elevate patient care, streamline operations, and drive meaningful outcomes. Electronic Health Record (EHR) Management: Details: Efficiently manage patient records, medical history, medications, [&hellip;]"
                canonical="https://www.hwplindia.com/industries/healthcare/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-healthcare-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Healthcare</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Healthcare</li>
                    </ul>
                </div>
            </section>
            <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of The Best Healthcare Software Development</h3>
                                <p className='email'>
                                    Welcome to Horizon Webinfo Pvt. Ltd. where innovation meets healthcare excellence. We’re dedicated to revolutionizing the healthcare landscape through cutting-edge software solutions designed to elevate patient care, streamline operations, and drive meaningful outcomes.
                                </p>
                            </section>
                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">Electronic Health Record (EHR) Management:</h3>
                                    <p>
                                        <strong>Details:</strong> Efficiently manage patient records, medical history, medications, and treatment plans in a secure and centralized EHR system.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Enhance data accuracy, streamline workflows, and provide comprehensive patient care.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Appointment Scheduling and Calendar Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Allow patients to schedule appointments online, integrate with calendars, and send automated reminders.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Reduce no-shows, optimize scheduling, and improve overall appointment management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Medical Billing and Invoicing</h3>
                                    <p>
                                        <strong>Details:</strong> Streamline billing processes, generate accurate invoices, and integrate with insurance systems for seamless claims processing.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Reduce billing errors, accelerate payment cycles, and improve financial management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Telemedicine and Virtual Consultations</h3>
                                    <p>
                                        <strong>Details:</strong> Enable virtual appointments, secure video consultations, and remote patient monitoring for enhanced accessibility.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Expand patient reach, improve healthcare access, and provide timely remote care.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Prescription Management</h3>
                                    <p>
                                        <strong>Details:</strong> Digitize prescription workflows, send e-prescriptions to pharmacies, and track medication adherence.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve prescription accuracy, reduce errors, and enhance medication management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Clinical Decision Support System (CDSS)</h3>
                                    <p>
                                        <strong>Details:</strong> Enable virtual appointments, secure video consultations, and remote patient monitoring for enhanced accessibility.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhance clinical decision-making, reduce errors, and improve patient outcomes.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Interoperability with Health Information Exchanges (HIEs)</h3>
                                    <p>
                                        <strong>Details:</strong> Facilitate seamless data exchange with external healthcare systems, promoting interoperability and continuity of care.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve care coordination, enhance data accuracy, and provide a comprehensive view of patient health.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Patient Portal for Engagement</h3>
                                    <p>
                                        <strong>Details:</strong> Provide patients with secure access to their health information, lab results, and communication with healthcare providers.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Empower patients, improve engagement, and enhance communication for better-informed healthcare decisions.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Remote Monitoring and Wearable Integration</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate with wearables and enable remote monitoring of vital signs, allowing healthcare professionals to track patient health remotely.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Enhance chronic disease management, detect early warning signs, and reduce hospital readmissions.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Security and Compliance Features</h3>
                                    <p>
                                        <strong>Details:</strong> Implement robust security measures, including data encryption, access controls, and compliance with healthcare regulations (e.g., HIPAA).
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Protect patient data, ensure regulatory compliance, and build trust in the security of healthcare information.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Reporting and Analytics Tools</h3>
                                    <p>
                                        <strong>Details:</strong>  Provide comprehensive reporting and analytics features for healthcare administrators to derive insights from data.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Support data-driven decision-making, identify trends, and optimize healthcare operations.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Collaboration and Communication Tools</h3>
                                    <p>
                                        <strong>Details:</strong> Facilitate secure communication and collaboration among healthcare teams, ensuring timely exchange of information.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve care coordination, enhance teamwork, and streamline communication workflows.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                        Meet Best  Healthcare Software 
                                        Development Company
                                    </h2>

                                    <p>
                                        We created a solution that facilitates healthy lifestyle by designing sustainable wellness programs that connect people to their benefits.This app allows in-app purchase, direct messaging with dieticians, wearable & app integration as well as online appointment scheduling to speed up medical care.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Healthimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}